import images from "./images";
let reviews = [
  {
    name: "Abhinav Malhotra",
    position: "Competitive Programmer",
    image: images.avatar1,
    review:
      "The dedication which is required in this competent field is possessed by Pushkar and I hope he achieves everything :)",
  },
  {
    name: "Vaibhav Gupta",
    position: "C++ Developer",
    image: images.avatar2,
    review:
      "He has a great curiosity in his field and I wish the best for him.",
  },
  {
    name: "Tina Goel",
    position: "Business Analyst",
    image: images.avatar3,
    review:
      "He is one of the few people who never stops learning and is a great enthusiast to achieve great things in life..Great things are coming...",
  },
  {
    name: "Zeeshan Dev",
    position: "Web Developer",
    image: images.avatar4,
    review: "A very passionate and intellectual guy",
  },
  {
    name: "Sarthak Sharma",
    position: "AI Enthusiast",
    image: images.avatar5,
    review:
      "Pushkar is a very consistent person and constantly tries to improve himself everyday. Best of luck to him!",
  },
];

export { reviews };
